namespace Dashboard {

    export class DashboardBookingDetails {

        bookingId: number;
        bookingTypeMap: {[key:string]:number};
        bookingInfoItemType: {[key:string]:number};

        isAtolProtectedBooking: boolean;
        displaySupplierRef: boolean;
        childActions: any;
        bookedItems: any;
        packageCost: any;
        template: any;
        booking: any;
        pah: {Amount: number, CurrencyCode: string};
        bk: any;
        leadPassengerEmail: string;
        emailSent: boolean;
        holidayDestination: string;
        holidayDestinationEnGb: string;
        daysToGo: number;
        nights: any;
        ActiveTab: string = 'Holiday';
        numberOfRooms: number;
        totalPackagePrice: any;
        Adults: any;
        Children: any;
        Infants: any;
        hotelsRooms: string[] = [];
        hotelsRoomsEnGb: any[] = [];
        holidayStartDate: any;
        holidayReturnDate: any;
        accessBooking: boolean = true;
        fallbackEn: boolean = false;

        constructor(
            private $routeParams:ng.route.IRouteParamsService,
            private dashboardBookingService,
            private imageService,
            private dateUtil,
            private resourceService:Core.ResourceService,
            private paymentsService,
            private mybTrack,
            private authService
        ) {
            this.bookingId = parseInt($routeParams['bookingId'], 10);
            this.bookingTypeMap = dashboardBookingService.getBookingTypeMap();
            this.bookingInfoItemType = dashboardBookingService.getBookingInfoItemType();
            if (TRPCONFIG.Domain.CultureCode !== TRPCONFIG.Domain.MYBDefaultCultureCode) {
                this.getFallbackEnGbData();
            }
            this.getBookingInfo();
            this.getBookingDetail();
        }

        getBookingInfo():void {
            this.dashboardBookingService.getBookingInfo(this.bookingId)
            .then((booking:any) => {
                this.booking = booking;
                this.pah = this.dashboardBookingService.getPahFromNotifications(booking.Notifications);
                this.accessBooking = this.canAccessBooking(booking);
                if (booking.BookingOptions && booking.BookingOptions.Actions) {
                    this.childActions = this.dashboardBookingService
                        .getChildActions(booking.BookingOptions.Actions, 'VIEWBOOKINGDETAILS');
                }
            });
        }

        canAccessBooking(bnd) {
            let access = true;
            // Checks bundle has a BookingUIStatus of 'OK'
            if (bnd.Status !== 1) {
                access = false;
            }
            return access;
        }

        resendEmailToLead(): void {
            this.dashboardBookingService.sendConfirmationEmail([this.leadPassengerEmail], this.bookingId).then(res => {
                this.emailSent = true;
                this.mybTrack.track('MYB - Resend Email');
            });;
        }

        getBookingDetail():void {
            this.dashboardBookingService.getBookingDetail(this.bookingId, true)
            .then((data:any) => {
                const finalTripItineraries = this.dashboardBookingService.filterFinalBookings(data.TripItineraries);
                data.FinalTripItineraries = finalTripItineraries;
                this.bk = data;
                this.leadPassengerEmail = data.LeadPassenger.Email;
                this.hotelsRooms = [];
                let holidayDestinationsArr: string[] = [];
                let EstabTitle: string = '';
                let roomText: any = {};
                finalTripItineraries.forEach((t) => {
                    t.Itineraries.forEach((i) => {
                        /* look for the earliest date in all booked products */
                        if (this.holidayStartDate) {
                            if (this.dateUtil.compareDates(this.holidayStartDate, i.StartDate) === 1) {
                                this.holidayStartDate = i.StartDate;
                            }
                        } else {
                            this.holidayStartDate = i.StartDate;
                        }
                        /* look for the last date in all booked products */
                        if (this.holidayReturnDate) {
                            if (this.dateUtil.compareDates(i.EndDate, this.holidayReturnDate) === 1) {
                                this.holidayReturnDate = i.EndDate;
                            }
                        } else {
                            this.holidayReturnDate = i.EndDate;
                        }
                    });
                });
                for (let i=0; i< data.TripItineraries.length; i++) {
                    const status = data.TripItineraries[i].BookingStatus;
                    if(data.TripItineraries[i].BookingType === 8 && (status === 2 || status === 20)) {
                        if (holidayDestinationsArr.indexOf(data.TripItineraries[i].Itineraries[0].Province) === -1
                        && data.TripItineraries[i].Itineraries[0].Province){
                            holidayDestinationsArr.push(data.TripItineraries[i].Itineraries[0].Province);
                        }
                        EstabTitle = data.TripItineraries[i].Itineraries[0].EstabTitle;
                        roomText = {
                            numberOfRooms : data.TripItineraries[i].Itineraries.length,
                            EstabTitle : EstabTitle,
                            EstabId : data.TripItineraries[i].Itineraries[0].EstabId
                        };
                        if (!EstabTitle) {
                            this.fallbackEn = true;
                        }
                        this.hotelsRooms.push(roomText);
                    }
                }
                this.holidayDestination = holidayDestinationsArr.toString();
                this.holidayDestination = this.holidayDestination.length > 1 ?
                this.holidayDestination.split(',').join(', ') : this.holidayDestination;
                this.Adults = [];
                this.Children = [];
                this.Infants = [];
                data.Passengers.forEach((Pass)=>{
                    if (Pass.TypeId === 1) {
                        this.Adults.push(Pass);
                    } else if (Pass.TypeId === 2) {
                        this.Children.push(Pass);
                    } else if (Pass.TypeId === 3) {
                        this.Infants.push(Pass);
                    }
                });
                if (this.holidayStartDate) {
                    this.daysToGo = this.dateUtil.numberOfNights(new Date(), this.holidayStartDate);
                }
                if (this.holidayStartDate && this.holidayReturnDate) {
                    this.nights = this.dateUtil.numberOfNights(this.holidayStartDate, this.holidayReturnDate);
                }

                this.template = data.Itineraries ?
                    `partials/dashboard/ItineraryTemplate?Type=${data.Booking.LongType.template}` : null;

                this.displaySupplierRef = data.BalanceDueInfo ?
                    !(data.Booking.Type === 1 && data.BalanceDueInfo.BalanceDueAmount >
                        TRPCONFIG.Domain.SupplierRefBalanceThreshold) : true;

                 if (data.BookedItemAndPackageCost) {
                    this.packageCost = (TRPCONFIG.Domain.PackagePrice || data.PackageId)
                        && data.BookedItemAndPackageCost.PackageCost;
                    this.isAtolProtectedBooking = data.BookedItemAndPackageCost.IsAtolProtected;
                    this.bookedItems = data.BookedItemAndPackageCost.BookedItems;
                    this.totalPackagePrice = this.sumCosts(this.bookedItems);
                }

                this.mybTrack.track('MYB - View Booking Details', {
                     PaidInFull: this.bk.BalanceDueInfo === null ? true : false
                });

                _.forEach(this.bk.ClearedPayments, (p:any) => {
                    p.LogoName = _.first(this.paymentsService.getLogosList([{ Title: p.CardTypeTitle }])) || 'external';
                });
            });
        }

        getFallbackEnGbData ():void {
            this.dashboardBookingService.getBookingDetail(this.bookingId, true, 'en-gb')
            .then((data:any) => {
                if(TRPCONFIG.Domain.MYBDefaultCultureCodeEnable) {
                    this.fallbackEn = true;
                }
                this.bk = data;
                const hotelData = this.getHotelsData(data);
                this.hotelsRoomsEnGb = hotelData[1];
                this.holidayDestinationEnGb = hotelData[0].toString();
                this.holidayDestinationEnGb = this.holidayDestinationEnGb.length > 1 ?
                this.holidayDestinationEnGb.split(',').join(', ') : this.holidayDestinationEnGb;
            });
        }

        getHotelsData(data) {
            let holidayDestinationsArr: string[] = [];
            let hotelsRooms: any[] = [];
            let roomText: any = {};
            for (let i=0; i< data.TripItineraries.length; i++) {
                const status = data.TripItineraries[i].BookingStatus;
                if(data.TripItineraries[i].BookingType === 8 && (status === 2 || status === 20)) {
                    if (holidayDestinationsArr.indexOf(data.TripItineraries[i].Itineraries[0].Province) === -1
                    && data.TripItineraries[i].Itineraries[0].Province){
                        holidayDestinationsArr.push(data.TripItineraries[i].Itineraries[0].Province);
                    }
                    roomText[data.TripItineraries[i].Itineraries[0].EstabId] = {
                        numberOfRooms : data.TripItineraries[i].Itineraries.length,
                        EstabTitle : data.TripItineraries[i].Itineraries[0].EstabTitle,
                        Address : data.TripItineraries[i].Itineraries[0].Address
                    };
                    hotelsRooms.push(roomText);
                }
            }
            return [holidayDestinationsArr, hotelsRooms];
        }

        getTitle(id) {
            if (this.hotelsRoomsEnGb && this.hotelsRoomsEnGb[0][id] && this.hotelsRoomsEnGb[0][id].EstabTitle) {
                return this.hotelsRoomsEnGb[0][id].EstabTitle;
            }
        }

        actionClick(action:{[key:string]:any}, bk:{[key:string]:any}):void {
            this.dashboardBookingService.actionClick(action, bk);
        }

        getResourceValue(resource:string):string {
            return this.resourceService.get(resource);
        }

        getPaymentTitle(payment){
            return `${payment.CardTypeTitle != null ?
                payment.CardTypeTitle : payment.Title != null ? payment.Title : ''}`;
        }

        sumCosts(costs) {
            return (costs || []).reduce((sum, cost) => {
                sum.total += (cost.Quantity * cost.UnitAmount);
                sum.netTotal += (cost.Quantity * cost.NetUnitAmount);
                sum.totalTravelAgentCommission += (cost.Quantity * cost.TravelAgentCommission);
                return sum;
        }, { total: 0, netTotal: 0, totalTravelAgentCommission: 0 });
        }

        signOut() {
            this.authService.signOut();
        }
    }

    angular
        .module('dashboard')
        .controller('DashboardBookingDetails', DashboardBookingDetails);
}
